import { versionConfig, statusConfig, regionConfig, languageConfig } from '../options.js';
export const snippets = {
    type: 'snippets',
    contentType: 'snippet',
    editor: 'html',
    editorTitle: { name: 'title', placeholder: 'title' },
    supportContent: [],
    documentProperty: 'content',
    title: 'Snippet',
    plural: 'Snippets',
    endpoint: 'snippets',
    version: versionConfig,
    listing: {
        type: 'grid',
        gridSupportContent: [],
        gridContentType: 'snippets',
        gridCombineProperty: 'slug',
        gridDecode: ['title'],
        gridJoin: { properties: ['region', 'language'] },
        gridFormat: [
            // todo: move gridDecode into normalized gridFormat { format: 'decode', properties: ['title'] },
            { format: 'date', properties: ['created', 'modified'] },
        ],
        gridColumns: ['title'],
        gridSearch: [{ key: 'title', combine: true }],
        gridHasChildren: true,
        gridFilters: [
            {
                label: 'Status',
                key: 'status',
                uppercase: false,
                default: false,
                value: 'published',
                options: statusConfig.options,
            },
            {
                label: 'Region',
                key: 'region',
                uppercase: false,
                default: true,
                options: regionConfig.options,
            },
            {
                label: 'Language',
                key: 'language',
                uppercase: false,
                default: true,
                options: languageConfig.options,
            },
        ],
    },
    queryProperties: [
        'id',
        'title',
        'slug',
        'status',
        'client',
        'region',
        'language',
        'created',
        'modified',
    ],
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
            {
                label: 'Created',
                name: 'created',
                input: 'datetime-local',
            },
        ],
        version: [
            { label: 'Slug', name: 'slug', input: 'text' },
            { label: 'Client', name: 'client', input: 'multiselect' },
            regionConfig,
            languageConfig,
        ],
        versioned: true,
    },
    meta: [
        {
            label: 'Notes',
            name: 'notes',
            input: 'textarea',
            description: 'Document notes.',
        },
    ],
    validate: [],
};
//# sourceMappingURL=snippets.js.map